import { Timestamp } from 'firebase/firestore';
import { SectionCard } from '../trainer/SectionCard';
import { Badge } from '../ui';
import { formatInTimezone } from '@/shared/utils/timezone';
import type { WorkoutSession } from '../../types';

interface WorkoutHistoryProps {
  sessions: WorkoutSession[];
  timezone?: string;
  onSessionClick: (sessionId: string) => void;
}

export function WorkoutHistory({ sessions, timezone, onSessionClick }: WorkoutHistoryProps) {
  const completedSessions = sessions.filter((s) => s.status === 'completed');

  return (
    <SectionCard
      eyebrow="History"
      title="Recent Sessions"
      action={
        <span className="text-xs text-gray-600 dark:text-slate-400">
          {completedSessions.length} completed
        </span>
      }
    >
      <div className="space-y-3">
        {completedSessions.length === 0 && (
          <p className="text-gray-600 dark:text-slate-400 text-sm">
            You haven&apos;t logged any sessions yet.
          </p>
        )}
        {completedSessions
          .sort(
            (a, b) =>
              (b.startedAt as Timestamp).toMillis() -
              (a.startedAt as Timestamp).toMillis()
          )
          .slice(0, 5)
          .map((session) => (
            <button
              key={session.id}
              onClick={() => onSessionClick(session.id)}
              className="w-full text-left p-4 rounded-xl border border-gray-200 dark:border-white/10 bg-gray-50 dark:bg-white/5 hover:bg-gray-100 dark:hover:bg-white/10 transition"
            >
              <div className="flex items-center justify-between gap-3">
                <div className="flex-1">
                  <p className="text-sm text-gray-600 dark:text-slate-400">
                    {session.workoutSnapshot.name}
                  </p>
                  <p className="font-medium text-gray-900 dark:text-white">
                    {formatInTimezone(
                      (session.startedAt as Timestamp).toDate(),
                      timezone
                    )}
                  </p>
                </div>
                <Badge
                  variant={
                    session.status === 'completed'
                      ? 'success'
                      : session.status === 'in_progress'
                      ? 'primary'
                      : 'default'
                  }
                >
                  {session.status.replace('_', ' ')}
                </Badge>
              </div>
            </button>
          ))}
      </div>
    </SectionCard>
  );
}
